import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
// import videobg from '../../../assets/img/video-bg/video-1.jpg';
import videobg from '../../../assets/img/video-bg/00.jpg';
import playicon from '../../../assets/img/icons/play.svg';
import lines from '../../../assets/img/lines/08.png';

function Video(props) {
    const [openVideo, setOpenVideo] = useState(false)


    const openVideoModal = () => {
        setOpenVideo(true)
    }
    return (
        <section className="video-section bg-img-c section-gap" style={{ backgroundImage: "url(" + videobg + ")" }}>
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-xl-7 col-lg-8 col-md-10 order-2 order-md-1">
                        <div className="video-text">
                            <div className="section-title left-border mb-30">
                                <span className="title-tag">Growing Together</span>
                                <h2 className="title">
                                    Changing Businesses And <br /> Lives Around The World Through Outsourcing
                                </h2>
                            </div>
                            <p>
                                His objective is to assist organizations by leveraging growth, increasing productivity,
                                managing costs, and freeing up time utilizing virtual/remote teams.
                                He is proud to be a Christ focused entrepreneur, husband to an amazing wife, and father
                                to two awesome adult children who love the Lord. JW started a non-profit that serves
                                Haiti and Africa. He has adopted a Win, Win, Win philosophy of helping businesses be
                                their very best through virtual team members and making a Global Impact by creating
                                professional work opportunities and donating 51% of all profits to ministries around
                                the world.
                            </p>
                            <Link to="/portfolio" className="main-btn">Learn More</Link>
                        </div>
                    </div>
                    <div className="col-lg-3 col-lg-4 col-md-2 order-1 order-md-2">
                        <div className="video-btn text-md-center wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="400ms">
                            <span onClick={openVideoModal} className="play-btn popup-video cursor" role="button">
                                <img src={playicon} alt="" />
                                <i className="fas fa-play" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="line-shape">
                <img src={lines} alt="Line" />
            </div>

            <ModalVideo channel="youtube" autoplay isOpen={openVideo} videoId="nvbdqnAjUwo" onClose={() => setOpenVideo(false)} />
        </section>
    );
}

export default Video;